export const HEADER_ROLES_NAME = "RoleIDs";
export const HEADER_RIGHTS_SETTINGS_VERSION = "RightsSettingsVersion";
export const HEADER_TRANSACTION_CONTEXT_ID_NAME = "ContextID";
